export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./certificates.vue?vue&type=template&id=073c6cf4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/certificates.vue?vue&type=template&id=073c6cf4&
// module id = 1340
// module chunks = 0